export const OptionAnswersActionTypes = {
  API_RESPONSE_SUCCESS: '@@option-answer/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@option-answer/API_RESPONSE_ERROR',

  GET_OPTION_ANSWER: '@@option-answer/GET_OPTION_ANSWER',
  LIST_OPTION_ANSWERS: '@@option-answer/LIST_OPTION_ANSWERS',
  ADD_OPTION_ANSWER: '@@option-answer/ADD_OPTION_ANSWER',
  UPDATE_OPTION_ANSWER: '@@option-answer/UPDATE_OPTION_ANSWER',
  DELETE_OPTION_ANSWER: '@@option-answer/DELETE_OPTION_ANSWER',

  RESET: '@@option-answer/RESET'
}
